<script>
    import MenorItems from "./MenorItems.js";
    import QandA from "./QandA.svelte";
</script>

<div class="title">El Catecismo Menor de Westminster</div>

<div class="block">
    {#each MenorItems as { number, question, answer, proofs }}
    <QandA
        number="{number}"
        question="{question}"
        answer="{answer}"
        proofs="{proofs}"
    />
    {/each}
</div>

<style>
    .section {
        padding: 4rem 3rem;
    }
</style>
